import type { ComponentProps } from 'preact';
import styles from './DisplayTime.module.css';

export interface DisplayTimeProps extends Omit<
  ComponentProps<'span'>,
  'children'
> {
  text: string;
  isRealTime?: boolean;
  paused?: boolean;
}

export function DisplayTime({
  text,
  isRealTime = false,
  paused = false,
  className,
  ...props
}: DisplayTimeProps) {
  const classes = [
    styles.time,
    isRealTime ? styles.timeRealtime : '',
    paused ? styles.timePaused : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} {...props}>
      {text}
    </span>
  );
}
